package core.config

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue

object CurrencyConfig {
    var defaultCurrencySymbol by mutableStateOf("$")
        private set

    var defaultCurrencyCode by mutableStateOf("USD")
        private set

    fun updateCode(code: String, symbol: String) {
        defaultCurrencySymbol = symbol
        defaultCurrencyCode = code
    }
}